import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-express-concierge-room',
  templateUrl: './express-concierge-room.component.html',
  styleUrls: ['./express-concierge-room.component.scss']
})
export class ExpressConciergeRoomComponent implements OnInit {
  profileId = '';

  ngOnInit(): void {
    const userStr = localStorage.getItem('user_details') || localStorage.getItem('user') || 'null';
    try {
      const u = JSON.parse(userStr);
      if (u) this.profileId = u._id || u.profile_id || u.id;
    } catch {}
    if (!this.profileId) {
      this.profileId = localStorage.getItem('profileId') || '';
    }
  }
}
